(function () {
  let isAddingToCart = false;
  let lastAddToCartAt = null;

  window.__showcaseCartStatus__ = {
    loading: false,
    success: false,
    data: null,
    updatedAt: null,
  };

  async function addToCart(state) {
    if (!state) return;
    if (isAddingToCart) return;

    isAddingToCart = true;

    window.__showcaseCartStatus__.loading = true;

    const properties = {
      label: state.display_name || "",
    };

    if (state.has_personalisation) {
      if (state.personalisation_text) {
        properties.personalisation_text = state.personalisation_text;
      }

      if (state.personalisation_image) {
        properties.personalisation_image = state.personalisation_image;
      }
    }

    const bundleKey = Date.now().toString();

    const items = [
      {
        id: parseInt(state.shopify_variant_id),
        quantity: 1,
        properties: {
          ...properties,
          _BundleKey: bundleKey,
        },
      },
    ];

    if (
      state.personalisation_text &&
      state.personalisation_text.trim() !== ""
    ) {
      items.push({
        id: 50606382809388,
        quantity: 1,
        properties: {
          _Freebie: "Yes",
          _BundleKey: bundleKey,
          Personalisation: state.personalisation_text,
        },
      });
    }

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        window.__showcaseCartStatus__ = {
          ...window.__showcaseCartStatus__,
          loading: false,
          success: false,
          error: data,
          updatedAt: Date.now(),
        };

        return;
      }

      window.__showcaseATCResponse__ = data;

      window.__showcaseCartStatus__ = {
        ...window.__showcaseCartStatus__,
        loading: false,
        success: true,
        data,
        updatedAt: Date.now(),
      };

      closeModal();

      document.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        }),
      );
    } catch (err) {
      window.__showcaseCartStatus__ = {
        ...window.__showcaseCartStatus__,
        loading: false,
        success: false,
        error: err,
        updatedAt: Date.now(),
      };
    } finally {
      isAddingToCart = false;

      window.__showcaseCartStatus__.loading = false;
    }
  }

  /* =====================================================
     NEW: Watch window.__SCROLL_WIDGET_STATE__.cartState
     instead of scraping console.log. This is the state
     object visible in devtools with add_to_cart /
     add_to_cart_at / shopify_variant_id etc.
  ===================================================== */

  function evaluateCartState(cs) {
    if (!cs) return;
    if (!cs.add_to_cart) return;

    const timestamp = cs.add_to_cart_at;

    // dedupe: only act once per distinct add_to_cart_at value
    if (timestamp && timestamp === lastAddToCartAt) return;
    if (timestamp) lastAddToCartAt = timestamp;

    addToCart(cs);
  }

  function watchCartStateOn(stateObj) {
    if (!stateObj || stateObj.__atcWatched__) return;
    stateObj.__atcWatched__ = true;

    let _cartState = stateObj.cartState;

    // Fire immediately in case it's already true when we attach
    evaluateCartState(_cartState);

    try {
      Object.defineProperty(stateObj, "cartState", {
        configurable: true,
        enumerable: true,
        get() {
          return _cartState;
        },
        set(newVal) {
          _cartState = newVal;
          evaluateCartState(newVal);
        },
      });
    } catch (e) {
      // If defineProperty fails (non-configurable), fall back to polling only
    }
  }

  // __SCROLL_WIDGET_STATE__ may not exist yet at script load time,
  // so poll until it appears, then attach the watcher.
  const attachInterval = setInterval(() => {
    if (window.__SCROLL_WIDGET_STATE__) {
      watchCartStateOn(window.__SCROLL_WIDGET_STATE__);
      clearInterval(attachInterval);
    }
  }, 200);

  // Belt-and-suspenders: also poll the current cartState's
  // add_to_cart_at directly, in case the widget mutates the
  // existing object in place instead of reassigning cartState
  // (which would bypass the defineProperty setter above).
  setInterval(() => {
    const cs =
      window.__SCROLL_WIDGET_STATE__ &&
      window.__SCROLL_WIDGET_STATE__.cartState;
    evaluateCartState(cs);
  }, 300);

  let widgetInitialized = false;

  const modal = document.getElementById("showcase-modal");

  const modalInner = document.getElementById("modal-inner");

  const offscreen = document.getElementById("widget-offscreen");

  const widgetEl = document.getElementById("my-widget");

  async function fetchCollectionProducts() {
    const path = window.location.pathname;

    if (!path.includes("/collections/")) return;

    const handle = path.split("/collections/")[1].split("/")[0].split("?")[0];

    if (!handle) return;

    const showcase_id =
      (window.__collectionShowcaseMap__ || {})[handle] || null;

    let page = 1;

    let allProducts = [];

    while (true) {
      const res = await fetch(
        `/collections/${handle}/products.json?limit=250&page=${page}`,
      );

      const data = await res.json();

      if (!data.products || data.products.length === 0) break;

      allProducts = allProducts.concat(data.products);

      if (data.products.length < 250) break;

      page++;
    }

    window.currentCollectionData = {
      handle,
      showcase_id,
      products: allProducts,
    };

    widgetInitialized = false;

    initWidget();
  }

  function initWidget() {
    if (widgetInitialized) return;

    if (!window.currentCollectionData) return;

    window.ShowcaseWidget.init({
      target: "#my-widget",
      showcase_id: window.currentCollectionData.showcase_id,
      shop: window.__showcaseShop__,
      productInfo: window.currentCollectionData,
      inW: offscreen.offsetWidth,
      inH: offscreen.offsetHeight,
      cartStatus: window.__showcaseCartStatus__,
      atcResponse: window.__showcaseATCResponse__,
    });

    widgetInitialized = true;
  }

  function openModal() {
    widgetEl.style.position = "absolute";

    widgetEl.style.inset = "0";

    widgetEl.style.width = "100%";

    widgetEl.style.height = "100%";

    modalInner.appendChild(widgetEl);

    modal.classList.add("active");

    modal.style.display = "flex";

    modal.style.visibility = "visible";

    modal.style.opacity = "1";

    modal.style.pointerEvents = "auto";

    document.body.style.overflow = "hidden";

    document.querySelector("header").style.display = "none";
  }

  function closeModal() {
    widgetEl.style.position = "";
    widgetEl.style.inset = "";

    offscreen.appendChild(widgetEl);

    void offscreen.offsetHeight;

    modal.classList.remove("active");
    modal.style.display = "none";
    modal.style.visibility = "hidden";
    modal.style.opacity = "0";
    modal.style.pointerEvents = "none";

    document.body.style.overflow = "";

    document.querySelector("header").style.display = "";
  }

  document
    .getElementById("open-showcase-btn")
    .addEventListener("click", openModal);
  
  document.getElementById("to_open_3d_modal").addEventListener("click", openModal);

  document
    .getElementById("close-showcase-btn")
    .addEventListener("click", closeModal);

  modal.addEventListener("click", (e) => {
    if (e.target === modal) closeModal();
  });

  fetchCollectionProducts();

  const _pushState = history.pushState.bind(history);

  history.pushState = function (...args) {
    _pushState(...args);

    fetchCollectionProducts();
  };

  window.addEventListener("popstate", fetchCollectionProducts);
})();
